/**
 * The Db2 for i evidence the scanner stores on a finding, as display rows.
 * Only for IBM i assets: other engines reuse some key names (sample_strategy)
 * and must not grow an IBM i block.
 */
const ORDER: Array<[key: string, label: string]> = [
  ['header_label', 'Column heading'],
  ['header_source', 'Heading from'],
  ['ccsid', 'CCSID'],
  ['ccsid_plan', 'CCSID handling'],
  ['sample_strategy', 'Sampling'],
  ['file_rows', 'Rows in file'],
  ['public_authority', '*PUBLIC authority'],
  ['authorization_list', 'Authorization list'],
];

function display(key: string, v: unknown): string | null {
  if (typeof v === 'number' && Number.isFinite(v)) return key === 'file_rows' ? v.toLocaleString('en-IN') : String(v);
  // Operator-facing IBM names (*USE, PAYAUTL), free text and the Debug-printed
  // plan are shown as written; only the scanner's own snake_case enums are
  // turned into words.
  if (typeof v === 'string' && v.length > 0) return key === 'header_source' || key === 'sample_strategy' ? v.replace(/_/g, ' ') : v;
  return null;
}

export function ibmiEvidenceRows(assetRef: string, metadata: Record<string, unknown>): Array<{ k: string; v: string }> {
  if (!assetRef.startsWith('db2i://')) return [];
  const rows: Array<{ k: string; v: string }> = [];
  for (const [key, label] of ORDER) {
    const v = display(key, metadata[key]);
    if (v !== null) rows.push({ k: label, v });
  }
  return rows;
}
